import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-x-2" }

import { withDefaults } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseTypography from './BaseTypography.vue';
import { useCookies } from '@vueuse/integrations/useCookies';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocaleSwitcher',
  props: {
    color: { default: 'var(--base-white)' }
  },
  setup(__props: any) {



const { locale } = useI18n();
const cookies = useCookies(['localeCookie']);

const changeLanguage = (lang: string) => {
    locale.value = lang;
    cookies.set('localeCookie', lang);
};

const onLoad = () => {
    const cookiesLocale = cookies.get('localeCookie');

    if (!cookiesLocale) return;
    changeLanguage(cookiesLocale);
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLanguage('ru')))
    }, [
      _createVNode(BaseTypography, {
        text: "РУ",
        type: "footnote",
        color: _ctx.color
      }, null, 8, ["color"])
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage('en')))
    }, [
      _createVNode(BaseTypography, {
        text: "EN",
        type: "footnote",
        color: _ctx.color
      }, null, 8, ["color"])
    ])
  ]))
}
}

})